import React, { Component } from 'react';
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {Checkbox} from 'primereact/checkbox';
import * as actions from '../../../store/actions/index';
import {Toast} from 'primereact/toast';
import {  SHIFT_SUBMENU_ID, DROPDOWN_CONFIG } from '../../../shared/Config';
import { HASACCESS, getNoOfDaysOptions, REDIRECT_TO_URL } from '../../../shared/utility';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import Messages from '../../../shared/UI/Messages/Messages';

class AddPeriodicSchedule extends Component {
    state = {
        display : true,
        dropdownEmployee: null,
        sunday : '1',
        monday : '2',
        tuesday : '3',
        wednesday : '1',
        thursday : '2',
        friday : '2',
        saturday: '1',
        manualDaysShift: false,
        manualDaysShift1:1,
        manualDaysShift2:1,
        loading : false,
        type : 'add',
        X_Drop_1_Shift : null,
        X_Drop_2_Shift : null,
        Id : null,
        code : '',
        name : '',
        description : ''
    }

    componentDidMount(){
        this.props.getMasterTableList('GetShiftPattern');  
        this.getAccess = HASACCESS(SHIFT_SUBMENU_ID);
        this.props.getMasterKeywordList && this.props.getMasterKeywordList('Shift');

        let type = this.props.match.params.type;
        if(type !== 'add'){
            setTimeout(() => {
                this.fetchSingleProcess();
            },1000)
        }
    }

    fetchSingleProcess = () =>{
   
        let id = this.props.match.params.id;   
        let type = this.props.match.params.type;
        let storageItems = [];

        if(this.props.tableLists.shiftPatternList!==undefined) {
            storageItems = this.props.tableLists.shiftPatternList;
        }

        if(storageItems){
            let filterData = storageItems.filter(list => {
                return parseInt(list.id) === parseInt(id);
            }).reduce((arr,el) => {
                return el;
            },{});
       

            if(filterData){
                var data = {
                    type:type,
                    sunday : filterData.sun,
                    monday : filterData.mon,
                    tuesday : filterData.tue,
                    wednesday : filterData.wed,
                    thursday : filterData.thu,
                    friday : filterData.fri,
                    saturday: filterData.sat,
                    description : filterData.description,
                    name : filterData.name,
                    code : filterData.code,
                    manualDaysShift: filterData.xbyx,
                    manualDaysShift1:filterData.xon,
                    manualDaysShift2:filterData.xoff,
                    X_Drop_1_Shift :filterData.xonShift,
                    X_Drop_2_Shift :filterData.xoffShift,
                    Id : filterData.shiftPatterId,
                }

                this.setState(data);
                
            }
        }

    }


    actionTemplate = (rowData, column) => {
        let rowIndex = column.rowIndex;
        return <div>
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.removeField(rowIndex)} ></Button>
        </div>;
    }

    documentAdd = () => {

        let newDoc = {no : 1, hour:'1 X 8 = 8hours',percentage:""};
  
        let docValue = [...this.state.rows, newDoc];
      
        this.setState({rows:docValue})
    }

    noEditor =  (props) => {
        return this.inputTextEditor(props, 'percentage');
    }
    onEditorValueChange = (props, value) => {
        let updatedValue = [...props.value];
        updatedValue[props.rowIndex][props.field] = value;
        this.setState({documentDetails: updatedValue});
    }

    inputTextEditor = (props, field) => {
        return <InputText type="text" value={props.rowData[field]} onChange={(e) => this.onEditorValueChange(props, e.target.value)} />;
    }


    removeField  = (removeIndex) => {

        const updatedDeptValue = this.state.rows.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({rows:updatedDeptValue})

    }

    onSubmit = (e) =>{
        let id = this.props.match.params.id;   

        const {code, name} = this.state;
        if(!code || !name){
            let msg = {severity: 'error', summary: 'Error Message', detail: 'Validation failed'};
            this.growl.show(msg);
        }
        else{
            const { userDetail } = this.props;
            const { description,manualDaysShift, manualDaysShift1, manualDaysShift2, sunday, monday, tuesday, wednesday, thursday, friday, saturday ,X_Drop_1_Shift, X_Drop_2_Shift} = this.state;
            let data = {
                Name :name,
                Description : description,
                Code : code,
                IsActive: true
            }
            data = manualDaysShift ? {...data, Xbyx: true, Xon: manualDaysShift1, XonShift :X_Drop_1_Shift, XoffShift :X_Drop_2_Shift, Xoff : manualDaysShift2} :  {...data, 
                Sun: sunday, Mon : monday, Tue: tuesday, Wed: wednesday, Thu : thursday, Fri : friday, Sat : saturday};
            
                if(this.state.type === 'add'){
                    data.CreatedDate = new Date();
                    data.CreatedBy = userDetail && userDetail.EmployeeName;
                }

                if(this.state.type === 'edit'){
                    data.Id = id;
                    data.ShiftPatterId =  this.state.Id;
                    data.UpdatedDate = new Date();
                    data.UpdatedBy = userDetail && userDetail.EmployeeName;
                }

                this.props.processDynamicData('ShiftPattern',this.state.type,data,'GetShiftPattern');
        }
    }

    resetData = () => {
        this.setState({name:'',code:'',description:''})
    }


    render() {   

        if(this.props.success){
            REDIRECT_TO_URL('/periodic-schedule/',this.props);
        }
        
        const { manualDaysShift } = this.state;
        const { shifts } = this.props;

        const manualDaysOptions = getNoOfDaysOptions(1, 10);
        const updatedShifts = shifts && Array.from(shifts, shift => {return shift && { label: shift.label, value: shift.value }});
        
        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}


        let isEnabled = (this.state.name!=='' && this.state.code!=='')
        return (
            <div className="p-grid">
                { this.state.loading && <div className="page-loader"></div>}
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title" style={{position:'relative'}}>
                        <h1>{this.state.type} Shift Pattern</h1>
                      
                        <div className="p-grid mt2">
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Code<span class="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="code"  onChange={(e) => this.setState({code : e.target.value})} required placeholder="Code" value={this.state.code}/></div>                                
                            </div>
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Name<span class="requiredColor">*</span></label>
                                <div className="mt1"><InputText className="p-col-12" name="name" placeholder="Name" onChange={event => this.setState({name: event.target.value})} value={this.state.name}/></div>                                
                            </div>
                         
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Decription</label>
                                <div className="mt1"><InputText className="p-col-12" name="description" placeholder="Decription" onChange={event => this.setState({description: event.target.value})} value={this.state.description}/></div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">X Checkbox</label>
                                <div className="mt1"><Checkbox className="p-col-12" checked={manualDaysShift} name="description" placeholder="Decription" onChange={event => this.setState({manualDaysShift: !manualDaysShift})}/></div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">SUN</label>
                                <div className="mt1">
                                <Dropdown disabled={manualDaysShift} className="p-col-12" options={updatedShifts} name="sunday" value={this.state.sunday} onChange={event => this.setState({sunday: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Shift" />
                                </div>                                
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">MON</label>
                                <div className="mt1">
                                <Dropdown disabled={manualDaysShift} className="p-col-12" options={updatedShifts} name="monday" value={this.state.monday} onChange={event => this.setState({monday: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Shift" />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">TUE</label>
                                <div className="mt1">
                                <Dropdown disabled={manualDaysShift} className="p-col-12" options={updatedShifts} name="tuesday" value={this.state.tuesday} onChange={event => this.setState({tuesday: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Shift" />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">WED</label>
                                <div className="mt1">
                                <Dropdown disabled={manualDaysShift} className="p-col-12" options={updatedShifts} name="wednesday" value={this.state.wednesday} onChange={event => this.setState({wednesday: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Shift" />
                                </div>                                
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">THU</label>
                                <div className="mt1">
                                <Dropdown disabled={manualDaysShift} className="p-col-12" options={updatedShifts} name="thursday" value={this.state.thursday} onChange={event => this.setState({thursday: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Shift" />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">FRI</label>
                                <div className="mt1">
                                <Dropdown disabled={manualDaysShift} className="p-col-12" options={updatedShifts} name="friday" value={this.state.friday} onChange={event => this.setState({friday: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Shift" />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                <label className="label">SAT</label>
                                <div className="mt1">
                                <Dropdown disabled={manualDaysShift} className="p-col-12" options={updatedShifts} name="saturday" value={this.state.saturday} onChange={event => this.setState({saturday: event.value})} {...DROPDOWN_CONFIG} placeholder="Select Shift" />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-6 p-lg-3">
                                                       
                            </div>

                            <div className="p-col-12  p-lg-12">
                                                   <hr/>    
                                                       </div>


                            <div className="p-col-12 p-md-4 p-lg-4">
                                <label className="label">X Drop 1</label>
                                <div className="mt1">
                                <Dropdown disabled={!manualDaysShift} className="p-col-12" options={manualDaysOptions} name="X_Drop_1" value={this.state.manualDaysShift1} onChange={event => this.setState({manualDaysShift1: event.value})} autoWidth={false} />
                                </div>                                
                            </div>
                            <div className="p-col-12 p-md-4 p-lg-4" style={{ textAlign: 'center',fontSize: '40px',fontWeight: 'bold'}}>
                               X                              
                            </div>

                            <div className="p-col-12 p-md-4 p-lg-4">
                                <label className="label">X Drop 2</label>
                                <div className="mt1">
                                <Dropdown disabled={!manualDaysShift} className="p-col-12" options={manualDaysOptions} name="X_Drop_2" value={this.state.manualDaysShift2} onChange={event => this.setState({manualDaysShift2: event.value})} autoWidth={false} />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-4 p-lg-4">
                                <label className="label">X Drop 1 Shift</label>
                                <div className="mt1">
                                <Dropdown disabled={!manualDaysShift} className="p-col-12" options={updatedShifts} name="X_Drop_1_Shift" value={this.state.X_Drop_1_Shift} placeholder="Select Shift"  onChange={event => this.setState({X_Drop_1_Shift: event.value})} autoWidth={false} />
                                </div>                                
                            </div>

                            <div className="p-col-12 p-md-4 p-lg-4" style={{ textAlign: 'center',fontSize: '40px',fontWeight: 'bold'}}>
                               X                              
                            </div>


                            <div className="p-col-12 p-md-4 p-lg-4">
                                <label className="label">X Drop 2 Shift</label>
                                <div className="mt1">
                                <Dropdown disabled={!manualDaysShift} className="p-col-12" options={updatedShifts} name="X_Drop_2_Shift" value={this.state.X_Drop_2_Shift} placeholder="Select Shift"  onChange={event => this.setState({X_Drop_2_Shift: event.value})} autoWidth={false} />
                                </div>                                
                            </div>


                            

                            <div className="p-col-12 p-lg-12">
                                <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.onSubmit} reset={this.resetData}   to={"/periodic-schedule"} />
                            </div>
                        </div>
                    
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        userDetail : state.auth.userObject,
        shifts : (state.keyword.Shift!==undefined) ? state.keyword.Shift : [],
        loading : state.master.loading,
        error : state.master.error,
        success:state.master.success,
        tableLists : state.master.tableLists,
    }
}

const mapDispatchToProps = dispatch => {
    return{
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(AddPeriodicSchedule);
